import { useEffect, useState } from 'react';

interface DebugSnapshot {
  mode: string;
  apiBase?: string;
  pathname?: string;
  userAgent?: string;
}

export default function DebugInfo() {
  const [snapshot, setSnapshot] = useState<DebugSnapshot | null>(null);

  useEffect(() => {
    if (import.meta.env.PROD) {
      return;
    }

    const nextSnapshot: DebugSnapshot = {
      mode: import.meta.env.MODE,
      apiBase: import.meta.env.VITE_API_BASE,
      pathname: window.location.pathname,
      userAgent: window.navigator.userAgent,
    };

    setSnapshot(nextSnapshot);
  }, []);

  if (import.meta.env.PROD || !snapshot) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed bottom-4 left-4 z-50 max-w-sm rounded-md border border-dashed border-blue-300 bg-white/90 p-3 text-xs font-mono text-gray-800 shadow-lg">
      <div className="mb-1 font-semibold uppercase tracking-wide text-blue-600">Debug Info</div>
      <pre className="whitespace-pre-wrap break-words">{JSON.stringify(snapshot, null, 2)}</pre>
    </div>
  );
}




















